import React, { useContext, useCallback } from 'react';
import { ProductDetailsContext } from '../../../context';
import { FormattedMessage } from 'react-intl';
import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { NumberInput } from 'ui-components/components/number-input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.css';

export const ToggleAndThreshold = () => {
  const { userHasPermission, shouldTrackInventory, setShouldTrackInventory, reorderThreshold, setReorderThreshold } =
    useContext(ProductDetailsContext);

  const onSetShouldTrack = useCallback(
    (e) => {
      setShouldTrackInventory(!e);
    },
    [setShouldTrackInventory],
  );

  return (
    <>
      <div className={style['inventory-container-flex']}>
        <div>
          <Text htmlFor='reorder-threshold-input' textType={TextType.Label} value={messages.reorderThreshold} />
          <NumberInput
            className={style['reorder-threshold-input']}
            disabled={!userHasPermission}
            id='reorder-threshold-input'
            onChange={setReorderThreshold}
            value={reorderThreshold}
          />
        </div>
        <CheckboxSlider
          checkboxId='toggle-inventory-tracking'
          checked={!shouldTrackInventory}
          className={style['checkbox-slider']}
          disabled={!userHasPermission}
          labelText={<FormattedMessage {...messages.toggleInventoryTracking} />}
          onChange={onSetShouldTrack}
        />
      </div>
    </>
  );
};
